export default __webpack_public_path__ + "static/media/swp-icon.ae3c37a4.svg";